var map = {
	"./icon-activity.svg": 1220,
	"./icon-arrow-left.svg": 1221,
	"./icon-bitbucket.svg": 1222,
	"./icon-broadcast.svg": 1223,
	"./icon-calendar.svg": 1224,
	"./icon-checkmark-sm.svg": 1225,
	"./icon-chevron-down.svg": 1226,
	"./icon-chevron-left.svg": 1227,
	"./icon-chevron-right.svg": 1228,
	"./icon-chevron-up.svg": 1229,
	"./icon-circle-add.svg": 1230,
	"./icon-circle-check.svg": 1231,
	"./icon-circle-close.svg": 1232,
	"./icon-circle-empty.svg": 1233,
	"./icon-circle-exclamation.svg": 1234,
	"./icon-circle-info.svg": 1235,
	"./icon-circle-question.svg": 1236,
	"./icon-circle-subtract.svg": 1237,
	"./icon-clipboard.svg": 1238,
	"./icon-clock-sm.svg": 1239,
	"./icon-close-lg.svg": 1240,
	"./icon-close.svg": 1241,
	"./icon-collapse.svg": 1242,
	"./icon-comment-sm.svg": 1243,
	"./icon-commit.svg": 1244,
	"./icon-copy.svg": 1245,
	"./icon-discover.svg": 1246,
	"./icon-docs.svg": 1247,
	"./icon-download.svg": 1248,
	"./icon-edit.svg": 1249,
	"./icon-exit.svg": 1250,
	"./icon-file.svg": 1251,
	"./icon-forward.svg": 1252,
	"./icon-generic-box.svg": 1253,
	"./icon-github.svg": 1254,
	"./icon-gitlab.svg": 1255,
	"./icon-health.svg": 1256,
	"./icon-history.svg": 1257,
	"./icon-input.svg": 1258,
	"./icon-issues.svg": 1259,
	"./icon-jira.svg": 1260,
	"./icon-labs.svg": 1261,
	"./icon-laptop.svg": 1262,
	"./icon-link.svg": 1263,
	"./icon-location.svg": 1264,
	"./icon-lock.svg": 1265,
	"./icon-mail.svg": 1266,
	"./icon-open.svg": 1267,
	"./icon-pin.svg": 1268,
	"./icon-power-features.svg": 1269,
	"./icon-print.svg": 1270,
	"./icon-project.svg": 1271,
	"./icon-projects.svg": 1272,
	"./icon-refresh.svg": 1273,
	"./icon-releases.svg": 1274,
	"./icon-return-key.svg": 1275,
	"./icon-search.svg": 1276,
	"./icon-sentry.svg": 1277,
	"./icon-settings.svg": 1278,
	"./icon-stack.svg": 1279,
	"./icon-star-small-filled.svg": 1280,
	"./icon-star.svg": 1281,
	"./icon-stats.svg": 1282,
	"./icon-support.svg": 1283,
	"./icon-trash.svg": 1284,
	"./icon-upgrade.svg": 1285,
	"./icon-user-multi.svg": 1286,
	"./icon-user.svg": 1287,
	"./icon-vsts.svg": 1288,
	"./icon-warning-sm.svg": 1289,
	"./icon-window.svg": 1290,
	"./icon-zendesk.svg": 1291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 688;